import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";

const Icon = ({ icon }: { icon: IconProp }) => <FontAwesomeIcon icon={icon} />;

export default Icon;
